<div class="grid">
  <div class="col-12 md:col-10 md:col-offset-1">
    <p-toast></p-toast>
    <div class="card">
      <p-tabView>

        <!-- ── Profile tab ─────────────────────────────────────────── -->
        <p-tabPanel header="Profile" leftIcon="pi pi-user mr-2">
          @if (profileLoading()) {
            <div class="flex justify-content-center py-6">
              <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
            </div>
          } @else {
            @if (profile(); as user) {
              <div class="grid mt-2">
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Full name</div>
                  <div class="text-900 font-medium text-lg">{{ user.firstName }} {{ user.lastName }}</div>
                </div>
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Email</div>
                  <div class="text-900 font-medium text-lg">{{ user.email }}</div>
                </div>
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Phone</div>
                  <div class="text-900 font-medium text-lg">{{ user.phoneNumber || 'N/A' }}</div>
                </div>
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Role</div>
                  <p-tag [value]="user.roleName | roleLabel" severity="info"></p-tag>
                </div>
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Store</div>
                  <div class="text-900 font-medium text-lg">{{ user.storeName || 'N/A' }}</div>
                </div>
                <div class="col-12 md:col-6 mb-4">
                  <div class="text-500 text-sm mb-1">Member since</div>
                  <div class="text-900 font-medium text-lg">{{ user.createdAt | date }}</div>
                </div>
              </div>
            } @else {
              <div class="text-center text-500 py-6">Could not load profile.</div>
            }
          }
        </p-tabPanel>

        <!-- ── Change password tab ─────────────────────────────────── -->
        <p-tabPanel header="Change Password" leftIcon="pi pi-key mr-2">
          <form class="grid p-fluid mt-2" [formGroup]="changeForm" (ngSubmit)="submit()">

            <div class="field col-12 md:col-6">
              <label for="oldPassword">Current password</label>
              <p-password
                inputId="oldPassword"
                formControlName="oldPassword"
                [toggleMask]="true"
                [feedback]="false"
                inputStyleClass="w-full"
                styleClass="w-full"
              ></p-password>
              <app-form-error [control]="changeForm.controls.oldPassword" label="Current password" />
            </div>

            <div class="col-12 md:col-6"></div>

            <div class="field col-12 md:col-6">
              <label for="newPassword">New password</label>
              <p-password
                inputId="newPassword"
                formControlName="newPassword"
                [toggleMask]="true"
                [feedback]="true"
                inputStyleClass="w-full"
                styleClass="w-full"
              ></p-password>
              <app-form-error [control]="changeForm.controls.newPassword" label="New password" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="confirmPassword">Confirm new password</label>
              <p-password
                inputId="confirmPassword"
                formControlName="confirmPassword"
                [toggleMask]="true"
                [feedback]="false"
                inputStyleClass="w-full"
                styleClass="w-full"
              ></p-password>
              <app-form-error [control]="changeForm.controls.confirmPassword" label="Confirm password" />
              @if (changeForm.errors?.['passwordsMismatch'] && changeForm.controls.confirmPassword.touched) {
                <small class="p-error">Passwords do not match.</small>
              }
            </div>

            <div class="col-12 flex justify-content-end mt-2">
              <button
                type="submit"
                pButton
                pRipple
                [label]="submitting() ? '' : 'Update password'"
                [icon]="submitting() ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                [disabled]="submitting()"
                class="p-button-success"
              ></button>
            </div>

          </form>
        </p-tabPanel>

      </p-tabView>
    </div>
  </div>
</div>
